import { boxShadows, corners, marginLeft, typography } from "../../styles";
import styled, { css } from "styled-components";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import React from "react";
import { useTranslation } from "react-i18next";
export type LoadingPillProps = {
  className?: string;
  hideBackground?: boolean;
};
const background = css`
  background-color: ${({
  theme
}) => theme.colours.white};
  ${boxShadows.subtleShadow}
  ${corners.xxl}
`;
const Container = styled.div<LoadingPillProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 8rem;
  max-width: fit-content;
  height: 3.5rem;

  text-transform: capitalize;

  ${({
  hideBackground
}) => !hideBackground ? background : null}
`;
const Text = styled.div`
  ${marginLeft.s}
  ${typography.bodyBold}
`;
export function LoadingPill({
  className,
  hideBackground
}: LoadingPillProps) {
  const {
    t
  } = useTranslation();
  return <Container className={className} hideBackground={hideBackground} data-sentry-element="Container" data-sentry-component="LoadingPill" data-sentry-source-file="LoadingPill.tsx">
      <LoadingSpinner data-sentry-element="LoadingSpinner" data-sentry-source-file="LoadingPill.tsx" />
      <Text data-sentry-element="Text" data-sentry-source-file="LoadingPill.tsx">{t("loading")}</Text>
    </Container>;
}
export default LoadingPill;